module.exports = __webpack_public_path__ + "static/media/guest-addressing.d19b5a3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/guest-addressing.svg
// module id = 1157
// module chunks = 47